// eslint-disable-next-line camelcase
import useSWR, { unstable_serialize, useSWRConfig } from 'swr'
import useSWRImmutable from 'swr/immutable'
import { FAST_INTERVAL, REFRESH_BLOCK_INTERVAL, SLOW_INTERVAL } from 'config/constants/intervals'
import { useWagmi } from 'libs/wagmi'

export const usePollBlockNumber = () => {
  const { cache, mutate } = useSWRConfig()
  const { chainId, provider } = useWagmi()

  const { data } = useSWR(
    chainId && ['blockNumberFetcher', chainId],
    async () => {
      const blockNumber = await provider.getBlockNumber()
      // Convert BigInt to number for Redux serialization
      const blockNumberAsNumber = Number(blockNumber)
      mutate(['blockNumber', chainId], blockNumberAsNumber)
      if (!cache.get(unstable_serialize(['initialBlockNumber', chainId]))) {
        mutate(['initialBlockNumber', chainId], blockNumberAsNumber)
      }
      return blockNumberAsNumber
    },
    {
      refreshInterval: REFRESH_BLOCK_INTERVAL,
    },
  )

  useSWR(chainId && [FAST_INTERVAL, 'blockNumber', chainId], async () => data, {
    refreshInterval: FAST_INTERVAL,
  })

  useSWR(chainId && [SLOW_INTERVAL, 'blockNumber', chainId], async () => data, {
    refreshInterval: SLOW_INTERVAL,
  })
}

export const useCurrentBlock = (): number => {
  const { chainId } = useWagmi()
  const { data: currentBlock = 0 } = useSWRImmutable(['blockNumber', chainId])
  return currentBlock
}
